import { ValidatorBase } from './ValidatorBase'
import { StringUtils } from '../../../Utils/StringUtils';

export class TimespanValidator extends ValidatorBase {

    public constructor(message: string, data: string) {
        super(message, data);
    }

    public validate(value: string, messages: string[]) {
        if (!/^((?:-?0*\d+\.)?(?:0*)(?:2[0-3]|1[0-9]|[0-9]))(?::0*([0-5]?[0-9]))?(?::0*((?:[0-5]?[0-9])(?:\.\d{0,7})?))?$/.test(value)) {
            let msg = StringUtils.isNullOrEmpty(this._message) ? "Value is not a valid time span. Valid formats are: d / d.hh:mm / d.hh:mm:ss / hh:mm" : this._message;
            messages.push(msg);
        }
    }

}


/** WEBPACK FOOTER **
 ** ./Typescript/Components/ConfigurationPanel/Validators/TimespanValidator.ts
 **/